module.exports = __webpack_public_path__ + "static/img/emails.e07657ab.svg";